<template>
	<div class="order">
		<!-- 顶部导航 -->
		<div class="nav">
			<van-icon name="arrow-left" color="#fff" size="1.2rem" @click="back" />
			<span>提交订单</span>
			<div></div>
		</div>
		<!-- 订单分类 -->
		<van-tabs v-model="active" @click="changes">
			<van-tab v-for="tabs in tabList" :title="tabs.title" :name="tabs.name">
				<!-- 等待付款 -->
				<div v-if="orderList.length == 0" class="tips">没有更多了~</div>
				<van-panel v-for="(item, index) in orderList" :key="index" v-else>
					<div slot="header" class="van-panel__header">
						<span>订单编号: {{item.order_number}}</span>
						<span class="color_f1" v-if="item.state == 0">等待付款</span>
						<span class="color_f1" v-else-if="item.state == 1">等待发货</span>
						<span class="color_f1" v-else-if="item.state == 2">等待收货</span>
						<span class="color_f1" v-else-if="item.state == 3">等待评价</span>
						<span class="color_f1" v-else-if="item.state == 4">已完成</span>
						<span class="color_f1" v-else-if="item.state == 5">已取消</span>
						<span class="color_f1" v-else>交易关闭</span>
					</div>
					<div class="content" @click="pays(item.order_number)">
						<div class="list" v-for="items in item.order_second">
							<van-card :num="items.num" :price="items.price" :title="items.goods_title" :thumb="items.goods_image| handleUrl">
								<!-- <div slot="tag" class="vant_tags">
									<van-tag v-if="items.category_id == 1" mark type="danger">租</van-tag>
									<van-tag v-if="items.category_id == 2" mark type="danger">购</van-tag>
									<van-tag v-if="items.category_id == 3" mark type="danger">淘</van-tag>
								</div> -->
								<div slot="bottom" class="color_b2">
									<span>{{items.goods_spec_name}}</span>
								</div>
							</van-card>
						</div>
					</div>
					<div slot="footer">
						<div v-if="item.indexs == '一次性买断（适用于长期使用）'">
							<div class="totals">
								<div class="logistics_price" style="color: red;">
									<div v-if="item.order_second[0].category_id == 1" style="position: relative; height: 30px; width: 100%;">
										<div style="position: absolute; top: 0; right: 0;">
											<span style="color: #000;">需支付<span style="font-weight: bold; color: red;">买断金额总计¥{{(item.total-item.logistics_price).toFixed(2)}}</span></span>
											<span>运输安装费¥{{item.logistics_price}}</span>
										</div>
									</div>
								</div>
								<div style="color: #b2b2b2;font-size: 0.75rem">市场购买参考含税价¥{{item.market_price}}</div>
								<div style="display: flex; justify-content: space-between;">
									<div>{{item.create_time}}</div>
									<div>
										<span>共{{item.order_second.length}}件商品</span>
										<span>合计<span class="color_f1_si1">¥{{item.total}}</span></span>
									</div>
								</div>
							</div>
						</div>
						<div v-else-if="item.indexs == '24个月+续租（适用于中长期使用）' ||item.indexs == '8个月+续租（适用于中短期使用）' ">
							<div class="totals">
								<div class="logistics_price" style="color: red;">
									<div v-if="item.order_second[0].category_id == 1" style="position: relative; height: 30px; width: 100%;">
										<div style="position: absolute; top: 0; right: 0;">
											<span style="color: #000; ">需支付<span style="font-weight: bold;color: red;">押金总计¥{{item.Lease_deposit_price}}</span></span>										<span>运输安装费: ¥{{item.logistics_price}}</span>

										</div>
									</div>
								</div>
								<div style="color: #000000;font-size: 0.75rem">
									月支付租金¥{{item.Lease_month_one_price}}　续租¥{{item.Lease_month_price}}/月
								</div>
								<div  style="color: #b2b2b2;font-size: 0.75rem">
									市场购买参考含税价¥{{item.market_price}}
								</div>
								<div style="display: flex; justify-content: space-between;">
									<div>{{item.create_time}}</div>
									<div>
										<span>共{{item.order_second.length}}件商品</span>
										<span>合计<span class="color_f1_si1">¥{{item.total}}</span></span>
									</div>
								</div>
							</div>
						</div>
						<div v-else>
							<div class="totals">
								<div class="logistics_price" style="color: red;">
									<div v-if="item.order_second[0].category_id == 1" style="position: relative; height: 30px; width: 100%;">
										<div  style="position: absolute; top: 0; right: 0;">
											<span v-if="item.lease_id == 4">首月租金<span style="font-size: 1.15rem;">¥{{item.Lease_deposit_price}}/月</span></span>
											<span v-if="item.lease_id == 7">首年租金<span style="font-size: 1.15rem;">¥{{item.Lease_month_one_price}}/月</span></span>
											<span v-if="item.lease_id == 6">买断租金<span style="font-size: 1.15rem;">¥{{(item.total-item.logistics_price).toFixed(1)}}</span></span>
											<span>运输安装费¥{{item.logistics_price}}</span>
										</div>
									</div>
								</div>
								<div style="display: flex; justify-content: space-between;">
									<div>{{item.create_time}}</div>
									<div>
										<span>共{{item.order_second.length}}件商品</span>
										<span>合计<span class="color_f1_si1">¥{{item.total}}</span></span>
									</div>
								</div>
							</div>
						</div>

						<div class="btn" v-if="item.state == 0">
							<van-button v-if="item.order_second[0].category_id == 1" round size="mini" style="width: 6rem;" @click="pays(item.order_number)">合同下载</van-button>
							<van-button round size="mini" @click="showPopup(item.id)">取消订单</van-button>
							<van-button v-if="item.gateway==1" round size="mini" color="#F1452F" @click="pays(item.order_number)" plain>上传支付凭证</van-button>
							<van-button v-else round size="mini" color="#F1452F" @click="pays(item.order_number)" plain>去支付</van-button>
						</div>
						<div class="btn" v-else-if="item.state == 1">
							<van-button v-if="item.order_second[0].category_id == 1" round size="mini" style="width: 6rem;" @click="pays(item.order_number)">合同下载</van-button>
							<van-button v-if="item.order_second[0].category_id == 1" round size="mini" style="width: 6rem;" @click="pays(item.order_number)">申请发票</van-button>
							<van-button round size="mini" color="#F1452F" plain @click="open53" style="width: 6rem;">提醒发货</van-button>
						</div>
						<div class="btn" v-else-if="item.state == 2">
							<van-button round size="mini" color="#F1452F" @click="cancel(3, item.id,item.order_number)" plain>确认收货</van-button>
						</div>
						<div class="btn" v-else-if="item.state == 3">
							<van-button round size="mini" color="#F1452F" plain @click="evaluate(item.order_number)">评价</van-button>
						</div>
						<div class="btn" v-else-if="item.state == 4">
							<van-button round size="mini">查看发票</van-button>
							<!-- <van-button round size="mini" color="#F1452F" plain>再次购买</van-button> -->
						</div>
						<div class="btn" v-else-if="item.state == 5">
							<van-button round size="mini" @click="delOrder(item.id, item.order_number)">删除订单</van-button>
							<!-- 							<van-button round size="mini" @click="Buyagain(item.order_number)" color="#F1452F" plain>再次购买</van-button> -->
						</div>
					</div>
				</van-panel>
			</van-tab>
		</van-tabs>
		<!-- 取消订单 -->
		<van-popup v-model="show" position="bottom" class="cancel">
			<div class="cancel_title">请选择取消订单的原因(必选):</div>
			<van-radio-group v-model="radio" @change="radios">
				<van-cell-group>
					<van-cell title="不想要了" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="不想要了" />
					</van-cell>
					<van-cell title="商品信息填写错误" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="商品信息填写错误" />
					</van-cell>
					<van-cell title="地址信息填写错误" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="地址信息填写错误" />
					</van-cell>
					<van-cell title="其他" clickable>
						<van-radio checked-color="#f1452f" slot="right-icon" name="其他" />
					</van-cell>
				</van-cell-group>
			</van-radio-group>
			<div class="cancel_btn">
				<button @click="cancel(5)">提交</button>
			</div>
		</van-popup>
	</div>
</template>

<script>
	import Like from '@/components/like/like'
	import Loding from '@/components/loding'

	export default {
		inject: ['reload'],
		data() {
			return {
				active: 0,
				show: false,
				radio: '不想要了',
				cancelId: -1,
				tabList: [{
					title: "全部",
					name: "-1"
				}, {
					title: "待支付",
					name: "0"
				}, {
					title: "待发货",
					name: "1"
				}, {
					title: "待收货",
					name: "2"
				}, {
					title: "待点评",
					name: "3"
				}, {
					title: "已完成",
					name: "4"
				}, {
					title: "已取消",
					name: "5"
				}],
				orderList: []
			}
		},
		created() {
			this.getData();
			if (!this.$route.query.index) {
				this.changes(-1);
			} else {
				this.changes(this.$route.query.index);
			}
		},
		methods: {
			//接收参数选择默认
			getData() {
				this.active = this.$route.query.index
			},
			//切换
			changes(name) {
				this.$axios.post(baseUrl + '/mobile/Order/order', {
					state: name,
					token: localStorage.getItem('Authorization')
				}).then((res) => {
					if (res.data.code == 2) {
						this.orderList = res.data.data;
						for (var i = 0; i < res.data.data.length; i++) {
							this.orderList[i].indexs = res.data.data[i].order_second[0].goods_spec_name.split(",")[1]
							console.log(this.orderList[i].indexs)
							this.orderList[i].tianshu= parseFloat(this.orderList[i].indexs)/2
						}
					} else {
						this.orderList = []
					}
				}).catch((err) => {
					console.log(err);
				})
			},
			pays(order_number) {
				this.$router.push({
					path: '/orderDetail',
					query: {
						order_number: order_number
					}
				})
			},
			//取消弹框
			showPopup(id) {
				this.show = true;
				this.cancelId = id;
			},
			//选择原因
			radios(name) {
				this.message = name;
			},
			// //再次购买
			// Buyagain(em){
			// 	this.$axios.post(baseUrl + '/mobile/Order/nextBuy', {
			// 		order_number:em,
			// 		token: localStorage.getItem('Authorization')
			// 	}).then(res=>{
			// 		this.$router.push({
			// 			path: '/orderDetail',
			// 			query: {
			// 				order_number: em
			// 			}
			// 		})
			// 	})
			// },
			//确认收货
			cancel(data, id, ddh) {
				var that = this;
				var obj = {};
				if (data == 5) {
					this.$dialog.confirm({
							title: '确定取消订单',
						})
						.then(() => {
							obj.id = that.cancelId;
							obj.state = data;
							obj.cancel_message = that.radio;
							that.$axios.post(baseUrl + '/mobile/Order/updateOrder', obj).then((res) => {
								that.show = false
								if (res.data.code == 1) {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/order',
										query: {
											index: 0
										}
									})
									this.$axios.post(baseUrl + '/mobile/Order/order', {
										state: 0,
										token: localStorage.getItem('Authorization')
									}).then((res) => {
										if (res.data.code == 2) {
											this.orderList = res.data.data;
										} else {
											this.orderList = []
										}
									}).catch((err) => {
										console.log(err);
									})
								} else {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/assess',
										query: {
											id: ddh
										}
									})
								}
							}).catch((err) => {
								console.log(err);
							})
						})
						.catch(() => {
							// on cancel
						});

				} else {
					this.$dialog.confirm({
							title: '确认收货',
						})
						.then(() => {
							obj.id = id;
							obj.state = data;
							that.$axios.post(baseUrl + '/mobile/Order/updateOrder', obj).then((res) => {
								that.show = false
								if (res.data.code == 1) {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/assess',
										query: {
											id: ddh
										}
									})
									this.$axios.post(baseUrl + '/mobile/Order/order', {
										state: 0,
										token: localStorage.getItem('Authorization')
									}).then((res) => {
										if (res.data.code == 2) {
											this.orderList = res.data.data;
										} else {
											this.orderList = []
										}
									}).catch((err) => {
										console.log(err);
									})
								} else {
									that.$toast(res.data.msg);
									that.$router.push({
										path: '/assess',
										query: {
											id: ddh
										}
									})
								}
							}).catch((err) => {
								console.log(err);
							})
						})
						.catch(() => {
							// on cancel
						});
				}
			},
			//删除订单
			delOrder(id, num) {
				this.$dialog.confirm({
					title: '确认删除订单',
				}).then(() => {
					this.$axios.post(baseUrl + '/mobile/Order/deleteOrder', {
						id: id,
						order_number: num
					}).then((res) => {
						if (res.data.code == 9) {
							this.$toast(res.data.msg);
							this.$axios.post(baseUrl + '/mobile/Order/order', {
								state: -1,
								token: localStorage.getItem('Authorization')
							}).then((res) => {
								if (res.data.code == 2) {
									this.orderList = res.data.data;
								} else {
									this.orderList = []
								}
							}).catch((err) => {
								console.log(err);
							})
						}
					}).catch((err) => {})
				}).catch(() => {
					// on cancel
				});
			},
			//评价
			evaluate(idx) {
				this.$router.push({
					path: '/assess',
					query: {
						id: idx
					}
				})
			},
		},
		components: {
			Like,
			Loding
		}
	}
</script>

<style scoped>
	@import 'order.css';
</style>



// WEBPACK FOOTER //
// src/components/min/order.vue